<template>
  <div :class="$style.frameParent">
    <h2>{{ title }}</h2>

    <div :class="$style.connectWithLendersSeeIfYParent" v-if="contains(1)">
      <div>Connect with lenders. See if you qualify.</div>
      <div :class="$style.thisWontAffect">
        This won’t affect your credit score
      </div>
      <div :class="$style.toggleAll" @click="toggleAll">
        <div v-if="!applied">Apply To All</div>
        <div v-else>Remove All</div>
      </div>
    </div>

    <div :class="$style.connectWithLendersSeeIfYParent">
      <div>
        {{ HEADER[userId ? userId.toString() : "defaultKey"] }}
      </div>
    </div>

    <div :class="$style.frameGroup">
      <div
        v-for="(card, index) in displayedCards"
        :key="index"
        :class="$style[card.class]"
        :style="{ backgroundColor: card.bgColor }"
      >
        <div :class="$style.frameDiv">
          <div :class="$style.cardContent">
            <div :class="$style.cardHeaderText">{{ card.headerText }}</div>
            <b :class="$style.cardTitle">{{ card.title }}</b>
            <div :class="$style.cardDescription">
              {{ card.description }}
            </div>
          </div>
          <div :class="$style.cardActions">
            <div :class="$style.applyContainer">
              <b
                v-if="!card.selected"
                :class="$style.applyBtn"
                @click="toggleIcon(index)"
                >{{ card.btnText }}</b
              >
              <img
                v-else
                src="/static/img/Checkbox.svg"
                @click="toggleIcon(index)"
                :class="$style.checkBoxIcon"
                alt="Check Box"
              />
            </div>
            <div :class="$style.moreContainer">
              <div @click="lenderURL(index)">More</div>
            </div>
          </div>
        </div>
        <div :class="$style.planeContainer">
          <div :class="$style.planeLine" />
          <img
            src="/static/img/plane.svg"
            :class="$style.planeIcon"
            alt="Plane Icon"
          />
        </div>
      </div>
    </div>

    <div v-if="showMoreBtn()" :class="$style.moreOptionsBtn" @click="showMore">
      <div>More options</div>
    </div>

    <div :class="$style.buttonContainer">
      <button type="button" :class="$style.nextButton" @click="handleNext">
        Finish
      </button>
      <div :class="$style.backButton" @click="$emit('onPrev')">
        <b :class="$style.name">Back</b>
      </div>
    </div>
    <div v-if="showCongratsModal" :class="$style.congratsOverlay">
      <div :class="$style.congratsModal">
        <h2>🎉 Congratulations!</h2>
        <p>You’ve successfully completed the sign-up process.</p>
        <p>Your flight school will reach out to you for onboarding.</p>
        <p>Once that’s complete, you’ll be able to log into the main app.</p>
        <button :class="$style.loginButton" @click="goToLoginPage">
          Go To Login Page
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import {
  LENDER_CONNECTION_CARD_TITLES as TITLES,
  LENDER_CONNECTION_HEADER as HEADER,
} from "../../../../../util/constants.js";
import LenderAPIService from "@/servicehandlers/LenderAPIService";
const lenderAPIService = new LenderAPIService();

export default defineComponent({
  props: {
    title: { type: String, required: true },
    userId: { type: Number, required: true },
    lenderId: { type: Number },
    userTypeId: { type: Number, required: true },
  },
  data() {
    return {
      cards: [],
      HEADER,
      applied: false,
      showOption: false,
      lenders: [],
      cardColors: [
        "#0088ff",
        "#53c7b6",
        "#1ca323",
        "#d55afb",
        "#ff4f4f",
        "#ffa42d",
      ],
      showCongratsModal: false,
    };
  },
  computed: {
    displayedCards() {
      return this.showOption ? this.cards : this.cards.slice(0, 6);
    },
  },
  async created() {
    try {
      this.lenders = await lenderAPIService.getLenders();

      const connectedLenders =
        await lenderAPIService.getPotentialLenderToStudentMapByUserId(
          this.userId,
        );
      const connectedLenderIds = connectedLenders.map(
        (entry) => entry.lenderId,
      );

      this.cards = this.lenders.map((lender, index) => {
        let card = {
          id: lender.id,
          class: "frameContainer",
          bgColor: this.cardColors[index % this.cardColors.length],
          selected: connectedLenderIds.includes(lender.id),
          URL: lender.url || "#",
        };

        switch (this.userTypeId) {
          case 1:
            card.headerText = "Lending Available";
            card.title = lender.name;
            card.btnText = "Apply";
            card.description =
              lender.description ||
              "Secure funding for your flight school with this lender. Schedule a call or apply now to get started.";
            break;
          default:
            card.headerText = "Personnel Needed";
            card.title = TITLES[index] || "Default Title";
            card.btnText = "Connect";
            card.description =
              "We are looking for aviation professionals to connect with.";
        }

        return card;
      });
    } catch (error) {}
  },
  methods: {
    contains(...ids) {
      return ids.includes(this.userTypeId);
    },
    toggleIcon(index) {
      this.cards[index].selected = !this.cards[index].selected;
    },
    toggleAll() {
      this.applied = !this.applied;
      this.cards.forEach((card) => (card.selected = this.applied));
    },
    showMoreBtn() {
      return this.cards.length > 6;
    },
    showMore() {
      this.showOption = !this.showOption;
    },
    lenderURL(index) {
      let url = this.cards[index].URL;

      if (url && url !== "#") {
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
          url = "https://" + url;
        }

        window.open(url, "_blank");
      }
    },
    async handleNext() {
      const selectedLenders = this.cards.filter((card) => card.selected);

      if (selectedLenders.length === 0) {
        alert("You must select at least one lender before proceeding.");
        return;
      }

      try {
        await Promise.all(
          selectedLenders.map((lender) =>
            lenderAPIService.createPotentialLenderToStudentMap({
              userId: this.userId,
              lenderId: lender.id,
            }),
          ),
        );

        this.showCongratsModal = true;
        // V2
        // this.$emit("onNext");
      } catch (error) {
        alert(
          "An error occurred while saving your selections. Please try again.",
        );
      }
    },
    goToLoginPage() {
      this.$router.push({ name: "Login" });
    },
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr;
  width: 100%;
}

.buttonContainer div,
.buttonContainer button {
  width: 100%;
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
  font-size: 16px;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameParent {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.applyBtn {
  position: relative;
  font-weight: bold;
  font-size: 12px;
  width: 100%;
}

.thisWontAffect {
  position: relative;
  font-size: 10px;
}

.toggleAll {
  border-radius: 5px;
  background-color: #3c78ff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  color: #fff;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.planeIcon {
  position: absolute;
  right: 40px;
  height: 70px;
  transform: rotate(8deg);
}

.connectWithLendersSeeIfYParent {
  align-self: stretch;
  height: 27px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
}

.cardHeaderText {
  width: 155px;
  font-size: 9px;
  position: relative;
  display: inline-block;
}

.cardTitle {
  width: 120px;
  position: relative;
  font-size: 13px;
  font-weight: 600;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cardDescription {
  width: 120px;
  position: relative;
  font-size: 11px;
  line-height: 14px;
  font-weight: 300;
  color: #fffffff7;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}

.cardContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 3px;
  box-sizing: border-box;
}

.applyContainer,
.moreContainer {
  width: 68px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 13px;
  background-color: #fff;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.applyContainer {
  background-color: #fff;
}

.moreContainer {
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.applyContainer:hover,
.moreContainer:hover,
.moreOptionsBtn:hover,
.toggleAll:hover {
  opacity: 0.8;
}

.cardActions {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  font-size: 13px;
  color: #404040;
}

.frameDiv {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 13px 13px 0;
  gap: 10px;
}

.planeLine {
  position: absolute;
  top: -39px;
  left: 243px;
  border-radius: 21px;
  border: 2px solid #fff;
  box-sizing: border-box;
  width: 103px;
  height: 298px;
  overflow: hidden;
  transform: rotate(65deg);
  transform-origin: 0 0;
}

.planeContainer {
  width: 180px;
  position: relative;
  height: 70px;
  overflow: hidden;
  flex-shrink: 0;
}

/*noinspection CssUnusedSymbol */
.frameContainer {
  border-radius: 9px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.moreOptionsBtn {
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.5);
  display: flex;
  flex-direction: row;
  height: 50px;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  font-weight: 400;
  font-size: 15px;
  transition: 0.2s ease-in-out;
}

.frameGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  font-size: 10px;
  color: #fff;
  margin-bottom: 30px;
}

/**toggle icon checkbox */
.checkBoxIcon {
  border-radius: 90px;
  height: 20px;
  width: auto;
}

.congratsOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.congratsModal {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.loginButton {
  margin-top: 20px;
  padding: 10px 25px;
  background-color: #3c78ff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}
</style>
